import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ROLE_PERMISSIONS } from '../config/permissions';

export const usePermissions = () => {
  const { role } = useContext(AuthContext);  // Changed from globalRole to role

  const hasPermission = (permission) => {
    if (!role) return false;
    return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
  };

  const hasAllPermissions = (permissions) => {
    return permissions.every(hasPermission);
  };

  const hasAnyPermission = (permissions) => {
    return permissions.some(hasPermission);
  };

  return {
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
  };
};